import { Component, Input } from '@angular/core';
import { CommonService } from '../../../../services/common.service';
import { environment } from '../../../../../environments/environment';
import { DefaultStyleDirective } from '../../../../flex-layout/style';
import { DefaultLayoutDirective } from '../../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../../flex-layout/custom-layout-align';
import { NgClass, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { DefaultClassDirective } from '../../../../flex-layout/class';

@Component({
  selector: 'calsoft-mobile-icon2',
  imports: [NgStyle, DefaultStyleDirective, DefaultLayoutDirective, DefaultLayoutAlignDirective, MatIcon, MatButton, NgClass, DefaultClassDirective],
  templateUrl: './mobile-icon2.component.html',
  styleUrl: './mobile-icon2.component.scss'
})
export class MobileIcon2Component {

  isHovered = false;
  public serverPath = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() data: any;

  @Input() img: any;

  constructor(
    private commonService: CommonService ) {}

  ngOnInit() {


    console.log(this.img);


    if (this.item.customField7 != undefined) {
      if (this.item.customField7.length > 0) {
        document.documentElement.style.setProperty('--hover--icon--colour', this.item.customField7);

      } else {
        document.documentElement.style.setProperty('--hover--icon--colour', 'var(--primary-color)');
      }
    }

    if (this.item.height != undefined) {
      if (this.item.height.length > 0) {
        document.documentElement.style.setProperty('--image--icon--size', this.item.height);
      } else {
        document.documentElement.style.setProperty('--image--icon--size', '280px');
      }
    }

  }


  imageNavigation(id :any){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url:any) {

    this.commonService.goToLink(url)
  }

  openInNewWindow(url: any): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
